// AccordionComponent.js
import React from "react";
import {
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  Box,
  Text,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  TableContainer,
  AccordionIcon,
} from "@chakra-ui/react";
import { FaCheckCircle, FaEdit } from "react-icons/fa";
import { accessOptions } from "./manageAccess";
import Form from "react-bootstrap/Form";
import { FormControl } from "react-bootstrap";

const AccordionComponent = ({
  id,
  authData,
  editActive,
  selectedModule,
  editValue,
  errors,
  handleEditModuleAccess,
  faEditClick,
  faCheckMarkClick,
}) => {
  return (
    <AccordionItem className="accordion-item" borderTop="none">
      <h2>
        <AccordionButton>
          <Box flex="1" textAlign="left">
            <Text className="accordion_title">
              {id} Module
            </Text>
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel className="accordion-panel  p-0 m-0">
        <TableContainer className="user-role mt-0">
          <Table size="md" variant="bubble" className="user-role-table">
            <Thead>
              <Tr>
                <Th className="module_name">Module</Th>
                <Th className="access">Access</Th>
                <Th>Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {authData &&
                authData.length > 0 &&
                authData?.map((item, index) => {
                  return (
                    <Tr>
                      <Td className="module_name">{item?.module}</Td>
                      <Td>
                        {editActive && selectedModule === item?.module ? (
                          <div className="dropdown-item selected">
                            <Form.Select
                              name="auth"
                              value={editValue?.access}
                              onChange={(e) => handleEditModuleAccess(e)}
                              isInvalid={!!errors.access}
                            >
                              {accessOptions?.map((option) => {
                                return (
                                  <option value={option.value}>
                                    {option.label}
                                  </option>
                                );
                              })}
                            </Form.Select>
                          </div>
                        ) : (
                          <div className="dropdown-item selected">
                            <FormControl
                              name="auth"
                              style={{ background: "none" }}
                              disabled
                              value={item?.access}
                            ></FormControl>
                          </div>
                          // <span className="mx-2">{item?.access}</span>
                        )}
                      </Td>
                      <Td>
                        {!editActive && !selectedModule ? (
                          <FaEdit
                            style={{
                              color: "#db8a2f",
                              cursor: "pointer",
                              marginLeft: "20px",
                            }}
                            onClick={() => {
                              faEditClick(item);
                            }}
                          />
                        ) : editActive && selectedModule === item?.module ? (
                          <FaCheckCircle
                            style={{
                              color: "green",
                              cursor: "pointer",
                              marginLeft: "20px",
                            }}
                            onClick={() => {
                              faCheckMarkClick(item);
                            }}
                          />
                        ) : (
                          <FaEdit
                            style={{
                              color: "#db8a2f",
                              cursor: "pointer",
                              marginLeft: "20px",
                            }}
                            onClick={() => {
                              faEditClick(item);
                            }}
                          />
                        )}
                      </Td>
                    </Tr>
                  );
                })}
            </Tbody>
          </Table>
        </TableContainer>
      </AccordionPanel>
    </AccordionItem>
  );
};

export default AccordionComponent;
